module.exports = __webpack_public_path__ + "static/assets/2c2af27f5e6bb0a7b5eb6d2a26e6c092.svg";